module.exports = __webpack_public_path__ + "img/hasta-2.50f85df6.png";